// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var fallback = "_5a-5";
export var fallbackIcon = "_5a-6";
export var hidden = "_5a-2";
export var image = "_5a-3";
export var loaded = "_5a-4";
export var placeholder = "_5a-1";